export const BRAND_NAME = 'Each Jewelry';
export const LEGAL_NAME = 'Each Jewelry RAA LLC';
export const CONTACT_EMAIL = 'admin@each-jewelry.com';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const REGISTERED_ADDRESS = '30 N Gould St Ste N, Sheridan, WY 82801, USA';
export const CONTACT_PHONE_DISPLAY = '+1 (307) 220-8099';
export const CONTACT_PHONE_TEL = 'tel:+13072208099';
export const CONTACT_PHONE_E164 = '+13072208099';
